document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('[data-product-share]');

  for (const wrapper of wrappers) {
    const button = wrapper.querySelector('[data-product-share-button]');
    const toast = wrapper.querySelector('[data-product-share-toast]');

    if (!button || !toast) continue;

    let toastTimeout = null;

    const showToast = () => {
      if (toastTimeout) clearTimeout(toastTimeout);

      toast.classList.remove('hidden');
      toast.classList.add('flex');

      toastTimeout = setTimeout(() => {
        toast.classList.add('hidden');
        toast.classList.remove('flex');
      }, 2500);
    };

    const copyLinkToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        showToast();
      } catch {
        // Clipboard access denied or unavailable — nothing else to fall back to.
      }
    };

    button.addEventListener('click', async () => {
      const { productShareTitle } = button.dataset;
      const shareData = {
        title: productShareTitle,
        url: window.location.href,
      };

      if (navigator.share && navigator.canShare?.(shareData)) {
        try {
          await navigator.share(shareData);
        } catch (error) {
          if (error.name !== 'AbortError') {
            copyLinkToClipboard();
          }
        }
        return;
      }

      copyLinkToClipboard();
    });
  }
});
